import styled from 'styled-components'

import SectionWrapper from 'components/SectionWrapper'

export const SectionsWrapperStyled = styled(SectionWrapper)`
  background-color: ${p => p.theme.colors.purpleHeart};
`
